import _ from "lodash";

export default {
    methods: {
        AddTheme() {
            this.themes.push({
                name: "",
                num: this.themes.length + 1,
                period: "",
                lecture: "",
                lecture_name: "",
                lecture_pp: "",
                practice: "",
                practice_name: "",
                practice_work: [],
                practice_pp: "",
                lesson_name: "",
                lesson: "",
                lesson_work: [],
                seminar_name: "",
                seminar: "",
                seminar_work: [],
                laboratory: "",
                laboratory_name: "",
                laboratory_pp: "",
                laboratory_work: [],
                ikr: "",
                kto: "",
                ke: "",
                control: "",
                indep_work: "",
                indep_work_name: "",
                control_form: "",
                lec_content_old: "",
                prac_content_old: "",
                lab_content_old: "",
                les_content_old: "",
                sem_content_old: "",
                indep_content_old: "",
                z_themes: false,
            })
        },
        AddZTheme() {
            this.themes.push({
                name: "",
                num: this.themes.length + 1,
                period: "",
                lecture: "",
                lecture_name: "",
                lecture_pp: "",
                practice: "",
                practice_name: "",
                practice_work: [],
                practice_pp: "",
                lesson_name: "",
                lesson: "",
                lesson_work: [],
                seminar_name: "",
                seminar: "",
                seminar_work: [],
                laboratory: "",
                laboratory_name: "",
                laboratory_pp: "",
                laboratory_work: [],
                ikr: "",
                kto: "",
                ke: "",
                control: "",
                indep_work: "",
                indep_work_name: "",
                control_form: "",
                lec_content_old: "",
                prac_content_old: "",
                lab_content_old: "",
                les_content_old: "",
                sem_content_old: "",
                indep_content_old: "",
                z_themes: true,
            })
        },
        sortThemes(){
            this.themes.sort(function(a, b) {
                return a.num - b.num;
            });
        },
        DelTheme(index){
            this.themes.splice(index, 1)
        },
        ChangeThemeName(index, name){
            this.themes[index].lecture_name = name;
            this.themes[index].practice_name = name;
            this.themes[index].laboratory_name = name;
            this.themes[index].indep_work_name = name;
        },
        AddSoftware(){
            this.software.push({info:{}})
        },
        DelSoftware(index){
            this.software.splice(index, 1)
        },
        AddResources(){
            this.resources.push({name: "", desc: ""})
        },
        DelResources(index){
            this.resources.splice(index, 1)
        },
        AddDataBases(){
            this.data_bases.push({name: "", desc: ""})
        },
        DelDataBases(index){
            this.data_bases.splice(index, 1)
        },
        AddPractice(index){
            this.themes[index].practice_work.push({work_name: "", content: ""})
        },
        DelPractice(index_theme, index_work){
            this.themes[index_theme].practice_work.splice(index_work, 1)
        },
        AddLaboratory(index){
            this.themes[index].laboratory_work.push({work_name: "", content: ""})
        },
        DelLaboratory(index_theme, index_work){
            this.themes[index_theme].laboratory_work.splice(index_work, 1)
        },
        AddLesson(index){
            this.themes[index].lesson_work.push({work_name: "", content: ""})
        },
        DelLesson(index_theme, index_work){
            this.themes[index_theme].lesson_work.splice(index_work, 1)
        },
        AddSeminar(index){
            this.themes[index].seminar_work.push({work_name: "", content: ""})
        },
        DelSeminar(index_theme, index_work){
            this.themes[index_theme].seminar_work.splice(index_work, 1)
        },
        AddForms(){
            this.forms.push({name: "", lec: "", prac: ""})
        },
        DelForms(index){
            this.forms.splice(index, 1)
        },
        AddControls(){
            this.spo_controls.push({result: "", control: ""})
        },
        DelControls(index){
            this.spo_controls.splice(index, 1)
        },
        AddStructure(){
            this.structure.push({part: "", content: "", time: 0})
        },
        DelStructure(index){
            this.structure.splice(index, 1)
        },
        AddDiscipline(){
            this.discipline.push({name: "", content: ""})
        },
        DelDiscipline(index){
            this.discipline.splice(index, 1)
        },
    }
}
